import { Link } from "gatsby"
import React from "react"

export default function Footer() {
  return (
    <footer>
      <div className="footer-links">
        <Link className="link" to="/introduction">
          The Issue
        </Link>
        <Link className="link" to="/projects">
          The Work
        </Link>
        <Link className="link" to="/about">
          About Us
        </Link>
        <Link className="link" to="/team">
          Team
        </Link>
        <Link className="link" to="/volunteer">
          Get Involved
        </Link>
      </div>
      <p>
        © Copyright <strong>Nenathambara Society Limited</strong>
      </p>
      <p> 2021 All Rights Reserved</p>
    </footer>
  )
}
